



























import { Component, Vue } from 'vue-property-decorator';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import { clientsModule } from '@/store';
import ServiceNavbar from './ServiceNavbar.vue';

@Component({
  name: 'service-layout',
  components: { UserMenu, MainNavbar, ServiceNavbar },
})
export default class ServiceLayout extends Vue {
  get client() {
    return clientsModule.model;
  }

  get hasAside() {
    return !!this.$slots.aside;
  }
}
